import React, { useState } from 'react'

import Logo from '../../../assets/ez-logo.png'
import { useLocation, useNavigate } from 'react-router-dom'
import {
    Button,
    FormControl,
    FormLabel,
    Grid,
    Snackbar,
    TextField,
    useTheme,
} from '@mui/material'
import { AppRoutes, LocalStorage, axiosInstance } from '../../../helpers'
import { FlexDiv } from '../../../components'
import { passwordValidator } from './passwordValidator'
import { PasswordRequirements } from './PasswordRequirements'

const useQuery = () => {
    const { search } = useLocation()

    return React.useMemo(() => new URLSearchParams(search), [search])
}

export const ForgotPassword = () => {
    const query = useQuery()
    const serverCode = query.get('code')
    const serverEmail = query.get('email')
    const inviteToken =
        query.get('invite') ||
        localStorage.getItem(LocalStorage.PENDING_INVITE_TOKEN)

    const theme = useTheme()
    const navigate = useNavigate()
    const [email, setEmail] = useState(serverEmail ?? '')
    const [code, setCode] = useState(serverCode ?? '')
    const [newPassword, setNewPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const [shownewPasswordBoxes, setShowNewPasswordBoxes] = useState(
        serverCode !== null,
    )
    const [toastOpen, setToastOpen] = useState(false)
    const [toastText, setToastText] = useState('')

    const showInstructions = serverCode === null || serverEmail === null

    const passwordValidResult = passwordValidator(newPassword, confirmPassword)

    return (
        <>
            <div>
                <Grid container spacing={2}>
                    <Grid
                        item
                        xs={12}
                        md={6}
                        style={{
                            height: 'calc(100vh - 16px)',
                            padding: '10px 4rem',
                        }}
                    >
                        <img src={Logo} alt="EZ Turn" />
                        <p
                            style={{
                                fontStyle: 'normal',
                                fontWeight: 600,
                                fontSize: '2.5rem',
                                margin: 0,
                                letterSpacing: '-0.035em',
                            }}
                        >
                            Reset Password
                        </p>

                        {showInstructions && (
                            <form noValidate autoComplete="off">
                                <p
                                    style={{
                                        fontWeight: 400,
                                        fontSize: '15px',
                                        lineHeight: '18px',

                                        color: '#000000',
                                    }}
                                >
                                    Enter the email associated with your account
                                    and we’ll send you an email with
                                    instructions to reset your password.
                                </p>
                                <FormLabel component="legend">Email:</FormLabel>
                                <FormControl
                                    fullWidth
                                    style={{ marginBottom: theme.spacing(1) }}
                                >
                                    <TextField
                                        id="email"
                                        placeholder="Email"
                                        variant="outlined"
                                        type="email"
                                        size="small"
                                        value={email}
                                        onChange={(e) => {
                                            setEmail(e.target.value)
                                        }}
                                    />
                                </FormControl>
                                <Button
                                    variant="contained"
                                    style={{
                                        background: '#008C85',
                                        color: '#FFF',
                                        fontSize: '0.875rem',
                                        textTransform: 'inherit',
                                        fontWeight: 500,
                                        borderRadius: '5px',
                                        boxShadow: 'none',
                                        width: '100%',
                                        marginBottom: theme.spacing(2),
                                    }}
                                    onClick={() => {
                                        axiosInstance.post(
                                            'user/forgot_password/',
                                            {
                                                set_code: true,
                                                email: email,
                                            },
                                        )
                                        setToastText(
                                            'That email will recieve a forgot pass code if it has an account',
                                        )
                                        setToastOpen(true)
                                        setShowNewPasswordBoxes(true)
                                    }}
                                >
                                    Send Instructions
                                </Button>
                            </form>
                        )}

                        <form noValidate autoComplete="off">
                            {shownewPasswordBoxes && (
                                <FlexDiv direction="column">
                                    <FormLabel component="legend">
                                        Password Code:
                                    </FormLabel>
                                    <FormControl
                                        fullWidth
                                        style={{
                                            marginBottom: theme.spacing(1),
                                        }}
                                    >
                                        <TextField
                                            id="code"
                                            placeholder="Code"
                                            variant="outlined"
                                            size="small"
                                            onChange={(e) => {
                                                setCode(e.target.value)
                                            }}
                                            value={code}
                                            disabled={true}
                                        />
                                    </FormControl>
                                    <FormControl
                                        fullWidth
                                        style={{
                                            marginBottom: theme.spacing(1),
                                        }}
                                    >
                                        <TextField
                                            id="new-pass"
                                            placeholder="New Password"
                                            variant="outlined"
                                            type="email"
                                            size="small"
                                            onChange={(e) => {
                                                setNewPassword(e.target.value)
                                            }}
                                        />
                                    </FormControl>
                                    <FormControl
                                        fullWidth
                                        style={{
                                            marginBottom: theme.spacing(1),
                                        }}
                                    >
                                        <TextField
                                            id="new-pass-confirm"
                                            placeholder="Confirm Password"
                                            variant="outlined"
                                            type="email"
                                            size="small"
                                            onChange={(e) => {
                                                setConfirmPassword(
                                                    e.target.value,
                                                )
                                            }}
                                        />
                                    </FormControl>
                                    <PasswordRequirements
                                        passwordRequirementResult={
                                            passwordValidResult
                                        }
                                        containerStyle={{
                                            marginLeft: theme.spacing(2),
                                            justifyContent: 'center',
                                        }}
                                    />
                                    <Button
                                        variant="contained"
                                        style={{
                                            backgroundColor:
                                                code === '' ||
                                                !passwordValidResult.passwordValid
                                                    ? undefined
                                                    : '#008C85',
                                            fontSize: '0.875rem',
                                            textTransform: 'inherit',
                                            fontWeight: 500,
                                            borderRadius: '5px',
                                            boxShadow: 'none',
                                            width: '100%',
                                        }}
                                        disabled={
                                            code === '' ||
                                            !passwordValidResult.passwordValid
                                        }
                                        onClick={() => {
                                            axiosInstance
                                                .post('user/forgot_password/', {
                                                    set_code: false,
                                                    code: code,
                                                    email: email,
                                                    new_password: newPassword,
                                                })
                                                .then(() => {
                                                    if (inviteToken) {
                                                        navigate(
                                                            `${AppRoutes.register}?invite=${inviteToken}`,
                                                        )
                                                    } else {
                                                        navigate(AppRoutes.login)
                                                    }
                                                    setToastText(
                                                        'Password Updated',
                                                    )
                                                    setToastOpen(true)
                                                })
                                                .catch(() => {
                                                    setToastText(
                                                        'Unable to change your password.  Please make sure the code you entered is correct.',
                                                    )
                                                    setToastOpen(true)
                                                })
                                        }}
                                    >
                                        Reset Password
                                    </Button>
                                </FlexDiv>
                            )}
                        </form>
                    </Grid>
                </Grid>
            </div>
            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                open={toastOpen}
                onClose={() => {
                    setToastOpen(false)
                }}
                message={toastText}
            />
        </>
    )
}
